import useSWR from 'swr';

import { SWRFetcher } from '@commenda/utils';

import {
  IUseWorkflowStepCompletionsParams,
  IWorkflowStepCompletionsResponse,
  WorkflowStepCompletionsKey,
} from './types';

export function useWorkflowStepCompletions(
  params: IUseWorkflowStepCompletionsParams | null
) {
  const { data, error, isLoading, mutate } = useSWR<
    IWorkflowStepCompletionsResponse[]
  >(
    params?.executionIds.length
      ? ['workflow-step-completions', params.executionIds, params.revision]
      : null,
    async ([, executionIds]: WorkflowStepCompletionsKey) =>
      Promise.all(
        executionIds.map((id) =>
          SWRFetcher({ method: 'GET' })(
            `workflow-execution/${encodeURIComponent(id)}/step-completions`
          )
        )
      ),
    { keepPreviousData: false, shouldRetryOnError: false }
  );
  return { data, error, isLoading, mutate };
}
